export default __webpack_public_path__ + "static/media/card-picture.e9542886.png";